import { ReactNode } from 'react';
import { FontReadyProvider } from './fonts.provider';
import { PerformanceProvider } from './performance.provider';
import { SmoothScrollProvider } from './smooth-scroll.provider';
import { VideoWidgetProvider } from './video-widget.provider';

export const AppProvider = ({ children }: { children: ReactNode }) => {
  return (
    <PerformanceProvider>
      <FontReadyProvider>
        <SmoothScrollProvider>
          <VideoWidgetProvider>{children}</VideoWidgetProvider>
        </SmoothScrollProvider>
      </FontReadyProvider>
    </PerformanceProvider>
  );
};
